import { Action } from 'redux';
// import { Customer } from 'src/types/model';

export interface DiscountState {
  loading: boolean;
  //   data: Customer[];
  data: any;
  error: string | null;
}

export const FETCH_DISCOUNT_REQUEST = 'FETCH_DISCOUNT_REQUEST';
export const FETCH_DISCOUNT_SUCCESS = 'FETCH_DISCOUNT_SUCCESS';
export const FETCH_DISCOUNT_FAILURE = 'FETCH_DISCOUNT_FAILURE';

export interface FetchDiscountRequestAction
  extends Action<typeof FETCH_DISCOUNT_REQUEST> {}

export interface FetchDiscountSuccessAction
  extends Action<typeof FETCH_DISCOUNT_SUCCESS> {
  payload: any[];
}

export interface FetchDiscountFailureAction
  extends Action<typeof FETCH_DISCOUNT_FAILURE> {
  payload: string;
}

export type DiscountActionType =
  | FetchDiscountRequestAction
  | FetchDiscountSuccessAction
  | FetchDiscountFailureAction;
